import camelCase from "lodash/camelCase";

const getSubdomain = () => {
  let host = window.location.host;
  let parts = host.split(".");
  let subdomain = "";

  if (parts.length >= 3) {
    subdomain = parts[0];
  }

  subdomain = subdomain.replace("-sandbox", "");
  // subdomain = `be-${subdomain}`;
  subdomain = camelCase(subdomain);

  return subdomain;
};

export default getSubdomain;
